import { Box, Grid, Typography } from "@mui/material";
import React, { useContext } from "react";
import { MainContext } from "../../../../main/context/MainContextProvider";

export type KPIComponentProps = {
    title: string;
    value: string | React.ReactNode;
    sufixx: string;
    icon: React.ReactNode;
    status?: "warning" | "danger";
    children?: React.ReactNode;
    gridSize?: { xs?: number; sm?: number; md?: number; lg?: number };
}

export default function KPIComponent(props: KPIComponentProps) {
    const { icon, sufixx, title, value, children, gridSize } = props

    const { theme } = useContext(MainContext);

    function getColorByStatus() {
        switch (props.status) {
            case "warning":
                return "#ff990081";
            case "danger":
                return "#f44336a1";
            default:
                return theme.cardBoxBackgroudColor;
        }
    }

    return (
        <Grid
            item
            xs={gridSize?.xs ?? 6}
            sm={gridSize?.sm}
            md={gridSize?.md ?? 2}
            lg={gridSize?.lg}
            sx={{ paddingRight: "4px" }}
        >
            <Box sx={{ height: "100%", backgroundColor: getColorByStatus(), borderRadius: "8px" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        gap: "12px",
                        padding: "12px",
                        paddingBottom: children ? "10px" : "12px",
                        textAlign: "left",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0, paddingTop: "2px" }}>{icon}</Box>
                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            textAlign: "left",
                            "& .MuiTypography-root": { textAlign: "left" },
                        }}
                    >
                        <Typography sx={{ fontWeight: "400", fontSize: "14px", textAlign: "left" }}>{title}</Typography>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                flexWrap: "nowrap",
                                gap: "6px",
                                marginTop: "4px",
                                justifyContent: "flex-start",
                                minWidth: 0,
                            }}
                        >
                            {typeof value === "string" ? (
                                <Typography sx={{ fontWeight: "900", fontSize: "18px", textAlign: "left", flexShrink: 1, minWidth: 0 }}>
                                    {value}
                                </Typography>
                            ) : (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        lineHeight: 1,
                                        gap: "6px",
                                        flexShrink: 1,
                                        minWidth: 0,
                                    }}
                                >
                                    {value}
                                </Box>
                            )}
                            {sufixx ? (
                                <Typography
                                    sx={{
                                        color: "#8F969E",
                                        fontWeight: "500",
                                        fontSize: "12px",
                                        textAlign: "left",
                                        flexShrink: 0,
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {sufixx}
                                </Typography>
                            ) : null}
                        </Box>
                        {children ? (
                            <Box
                                sx={{
                                    marginTop: "8px",
                                    width: "100%",
                                    "& .MuiBox-root": { justifyContent: "flex-start" },
                                }}
                            >
                                {children}
                            </Box>
                        ) : null}
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
}